import React, {Component} from 'react';
// import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import debounce from 'lodash/debounce';
import * as _ from "lodash";

import template from '../../../templates/PageLayout/Popups/AssignSalesPersonPopup.rt';
import {getSalesPeople, getFabricators, assignSalesPerson, selectSalesPerson
    } from './../../../components/Fabricators/FabricatorsActions';
import * as popupActions from './../../../actions/A_Popups';
import * as Misc from "../../../misc";
import {showFabricatorsPopup} from "./../../../actions/A_Popups";

class AddSalesPersonPopup extends Component {
  constructor(props) {
    super(props);

    let rows = this.props.rows;
    const idx = rows.length ? _.findIndex(rows, this.isRowSelected) : -1;
    if (idx !== -1) {
      Misc.arrayMove(rows, idx, 0);
    }

    this.state = {
      searchText: '',
      ...this.getLabels(),
      rows,
      isMaster: this.props.isMaster,
      showSetMasterProfile: this.props.popupAction === salesPersonPopupActions.setMasterProfile
    };

    switch (this.props.popupAction){
      case salesPersonPopupActions.setMasterProfile:
      case salesPersonPopupActions.chooseFabricator:
        this.debouncedSearchTextChanged = debounce(this.props.getFabricators, 250);
        break;
      default:
        this.debouncedSearchTextChanged = debounce(this.props.getSalesPeople, 250);
    }
  }

  componentWillReceiveProps(newProps) {
    if (this.props.rows !== newProps.rows && this.props.rows.length !== newProps.rows.length
      || this.props.page !== newProps.page) {
      let rows = newProps.rows;
      const idx = rows.length ? _.findIndex(rows, this.isRowSelected) : -1;
      if (idx !== -1) {
        Misc.arrayMove(rows, idx, 0);
      }
      this.setState({rows});
    }
  }

  getLabels = () => {
    switch (this.props.popupAction) {
      case salesPersonPopupActions.setMasterProfile:
        return {
          title: 'Set Master Profile',
          buttonAssign: 'Set'
        };
      case salesPersonPopupActions.chooseFabricator:
        return {
          title: 'Choose a Fabricator',
          buttonAssign: 'Set'
        };
      default:
        return {
          title: 'Assign Sales Person',
          buttonAssign: 'Assign'
        }
    }
  };

  componentDidMount(){
    switch (this.props.popupAction){
      case salesPersonPopupActions.setMasterProfile:
      case salesPersonPopupActions.chooseFabricator:
        this.props.getFabricators();
        break;
      default:
        const {job} = this.props;
        this.props.getSalesPeople(job.id, job.jobIdType);
    }
  }

  handleSearchTextChanged = (e) => {
    const {value} = e.target;
    switch (this.props.popupAction){
      case salesPersonPopupActions.setMasterProfile:
      case salesPersonPopupActions.chooseFabricator:
        this.setState({searchText: value}, () => {
          this.debouncedSearchTextChanged(value);
        });
        break;
      default:
        const {job} = this.props;
        this.setState({searchText: value}, () => {
          this.debouncedSearchTextChanged(job.id, job.jobIdType, 0, value);
        });
    }
  };

  handleAssign = (e) => {
    Misc.ignoreDefault(e);
    switch (this.props.popupAction) {
      case salesPersonPopupActions.setMasterProfile:
        this.props.newEntitySetMasterProfile({isMaster: this.state.isMaster});
        break;
      case salesPersonPopupActions.chooseFabricator:
        if (this.props.selectedId) {
          this.props.data.cb(_.find(this.props.rows, {id: this.props.selectedId}), true);
          this.props.hideMe();
        }
        break;
      default:
        this.props.assignSalesPerson();
    }
  }

  handleCancel = (e) => {
    switch (this.props.popupAction) {
      case salesPersonPopupActions.chooseFabricator:
        this.props.data.cb(null, false);
        this.props.hideMe();
        break;
      default:
        this.props.onCancel();
        break;
    }
  }

  getRowText = (row, columnIndex) => {
    switch (this.props.popupAction) {
      case salesPersonPopupActions.setMasterProfile:
      case salesPersonPopupActions.chooseFabricator:
        switch (columnIndex) {
          case -1: return row.id; //key
          case 0: return row.name;
          case 1: return _.first(row.emails);
        }
        break;
      default:
        switch (columnIndex) {
          case -1: return row.userId; //key
          case 0: return row.userName;
          case 1: return row.customerName;
        }
    }
  };

  isRowSelected = (row) => {
    switch (this.props.popupAction) {
      case salesPersonPopupActions.setMasterProfile:
      case salesPersonPopupActions.chooseFabricator:
        return row.id === this.props.selectedId;
      default:
        return row.userId === this.props.selectedId;
    }
  };

  selectRow = (row) => {
    this.props.selectRow(this.getRowText(row, -1));
  };

  toggleSetAsMaster = () => {
    this.setState({isMaster: !this.state.isMaster});
  }

  handlePageClick = page => {
    switch (this.props.popupAction) {
      case salesPersonPopupActions.setMasterProfile:
      case salesPersonPopupActions.chooseFabricator:
        this.props.getFabricators(this.state.searchText, page - 1);
        break;
      default:
        const {job} = this.props;
        this.props.getSalesPeople(job.id, job.jobIdType, page - 1, this.state.searchText)
        break;
    }
  }

  render = template
}

const mapStateToProps = (state) => {
  let rows = [];
  let page = 0;
  let totalPages = 0;
  const {newaccount} = state;
  const assignSalesPersonObj =  state.popups.assignSalesPerson.toJS();
  const {popupAction} = assignSalesPersonObj;
  switch (popupAction) {
    case salesPersonPopupActions.setMasterProfile:
    case salesPersonPopupActions.chooseFabricator:
      rows = state.fabricators.data.rows;
      page = state.fabricators.data.page;
      totalPages = state.fabricators.data.totalPages;
      break;
    default:
      rows = state.jobBoard.salesPeople.get('rows');
      rows = rows ? rows.toJS() : [];
      page = state.jobBoard.salesPeople.get('page');
      totalPages = state.jobBoard.salesPeople.get('totalPages');
      break;
  }

  return {
    ...assignSalesPersonObj,
    rows,
    page,
    totalPages,
    isMaster: newaccount.customerInfo.masterProfile ? newaccount.customerInfo.masterProfile.isMaster : false,
    masterFabricatorId: newaccount.customerInfo.masterProfile ? newaccount.customerInfo.masterProfile.id : 0
  };
};

const mapDispatchToProps = dispatch => ({
  getSalesPeople: (jobId, jobIdType, page = 0, searchKeyword = '') => dispatch(getSalesPeople(jobId, jobIdType, searchKeyword, page)),
  getFabricators: (searchKeyword, page = 0, pageSize = 50) => dispatch(getFabricators(page, pageSize, searchKeyword)),
  onCancel: () => dispatch(popupActions.assignSalesPerson(null, false)),
  selectRow: id => dispatch(selectSalesPerson(id)),
  assignSalesPerson: () => dispatch(assignSalesPerson()),
  newEntitySetMasterProfile: (data) => dispatch(popupActions.newEntitySetMasterProfile(data)),
  hideMe: () => dispatch(showFabricatorsPopup(false))
});

export const salesPersonPopupActions = {
  setMasterProfile: 1,
  chooseFabricator: 2
};

export default connect(mapStateToProps, mapDispatchToProps)(AddSalesPersonPopup);
